// This file is generated by scripts/generate.mjs — do not edit.
// Source: svg/close.svg
import { IconBase } from "./icon-base";
import type { IconProps } from "./types";

export function CloseIcon(props: IconProps) {
	return (
		<IconBase viewBox="0 0 16 16" {...props}>
			<path
				d="M12.5596 2.55762C12.8035 2.31378 13.1993 2.31395 13.4434 2.55762C13.6874 2.80169 13.6874 3.19831 13.4434 3.44238L9.24223 7.64352C9.04696 7.83878 9.04696 8.15536 9.24223 8.35062L13.4521 12.5605C13.6962 12.8046 13.6962 13.2012 13.4521 13.4453C13.2081 13.689 12.8123 13.6891 12.5684 13.4453L8.3575 9.23445C8.16222 9.03917 7.84561 9.03919 7.65035 9.23449L3.44043 13.4453C3.19636 13.6889 2.80059 13.6891 2.55664 13.4453C2.3127 13.2014 2.31298 12.8056 2.55664 12.5615L6.76672 8.34965C6.96191 8.15437 6.96187 7.83785 6.76664 7.64262L2.56543 3.44141C2.32177 3.1973 2.32149 2.80156 2.56543 2.55762C2.80938 2.3138 3.20515 2.31399 3.44922 2.55762L7.65039 6.75879C7.84564 6.95404 8.16219 6.95405 8.35746 6.75883L12.5596 2.55762Z"
				fill="currentColor"
			/>
		</IconBase>
	);
}
